import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'price'
})
export class PricePipe implements PipeTransform {

  transform(value: number) {
    const euros = value / 100;
    return `${euros.toLocaleString('de-DE', {style: 'currency', currency: 'EUR'})}`;
  }

}
